export default __webpack_public_path__ + "static/media/swap-fees-header-bg.31bf8d62.png";